<template>
    <div>
    <div class="index_body">
        <div class="index_main">
            <div class="ynjcws_logo"><img src="../assets/imgs/logo.png" width="515" height="48"></div>
            <div class="main_box">
                <div class="mb_left">
                    <a href="javascript:;" @click="openTarget(DAXX)" class="daxxglxt" title="基层医疗卫生机构档案信息管理"><span></span></a>
                    <a href="javascript:;" @click="openTarget(BMGL)" class="bmglxt" title="基层卫生人员培训报名管理系统"><span></span></a>
                    <a href="javascript:;" @click="openTarget(GWPX)" class="pxykhxt" title="基层卫生人员岗位培训与考核系统"><span></span></a>
                </div>
                <div class="mb_left" style="float: right;">
                    <a href="javascript:;" @click="openTarget(ZRPX)" class="pxhkhxt" title="乡村医生准入培训和考核系统"><span></span></a>
                    <a href="javascript:;" @click="openTarget(ZCXX)" class="xxglxt" title="乡村医生执业注册信息管理系统"><span></span></a>
                    <a href="./erjiliebiao.html" class="tzgg" title="通知公告"><span></span></a>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
    <div class="mb_copy">Copyright &copy; 2012-{{year}} 北京亿和博嘉教育科技有限公司 版权所有<br><a style="padding-right: 20px;" href="http://beian.miit.gov.cn" target="_blank">京ICP备12019974号</a><span style="padding-right: 15px;">经营许可证编号京B2-20180132</span>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025121" style="position: relative;padding-left: 23px;">
            <img src="http://source.yiboshi.com/public/img/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png"  style="width: 20px;height: 20px;position: absolute;left:0;top:0"/>
            京公网安备&nbsp;&nbsp;11010802025121号
        </a></div>

    </div>

    <!--<div class="index_body">
        <div class="index_main">
            <div class="main_box">
                <div class="mb_left">
                    <a href="javascript:;" @click="openTarget(DAXX)" class="daxxglxt" title="基层医疗卫生机构档案信息管理"><span></span></a>
                    <a href="javascript:;" @click="openTarget(BMGL)" class="bmglxt" title="基层卫生人员培训报名管理系统"><span></span></a>
                    <a href="javascript:;" @click="openTarget(GWPX)" class="pxykhxt" title="基层卫生人员岗位培训与考核系统"><span></span></a>
                    <a href="javascript:;" @click="openTarget(ZCXX)" class="xxglxt" title="乡村医生执业注册信息管理系统"><span></span></a>
                </div>
                <div class="mb_left" style="padding-top: 294px;">
                    <a href="javascript:;" @click="openTarget(ZRPX)" class="pxhkhxt" title="乡村医生准入培训和考核系统"><span></span></a>
                </div>
                <div class="clear"></div>
            </div>
            <a href="http://7xpvnz.com1.z0.glb.clouddn.com/yzfwjccl-20190209.zip" class="DataDownload">点击下载《优质服务基层行文件资料》</a>
            <div class="mb_copy">Copyright &copy; 2012-2019 北京亿和博嘉教育科技有限公司 版权所有 京ICP备12019974号</div>
        </div>
    </div>-->
</template>

<script>
    import {getRecommendList} from '../api/api';
    import  header1 from '../components/Header1';
    import  navigation from '../components/Navigation';
    import  footer1 from '../components/Footer1';
    import  newsSimpleList from '../components/NewsSimpleList';
    import  links from '../components/Links';
    import  newsList from '../components/NewsList';

    export default {
        name: 'index',
        components: {
            header1,
            footer1,
            navigation,
            newsSimpleList,
            links,
            newsList
        },


        data () {
            return {
                ZRPX: process.env.VUE_APP_API_ZRPX_URL,
                ZCXX: process.env.VUE_APP_API_ZCXX_URL,
                BMGL: process.env.VUE_APP_API_BMGL_URL,
                GWPX: process.env.VUE_APP_API_GWPX_URL,
                DAXX: process.env.VUE_APP_API_DAXX_URL,
                topCarousel:[],
                noticeNewsSettings: {//通知公告资讯参数
                    consultId: 52,
                    consultName: '通知公告',
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 7,
                    showPublishTime:true,
                    moreUrl:'/notice'
                },
                policiesAndRegulationsSettings: {//政策法规资讯参数
                    consultId: 55,
                    consultName: '政策法规',
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 7,
                    showPublishTime:true,
                    moreUrl:'/policiesAndRegulations'
                },
                downloadSettings: {//下载专区资讯参数
                    consultId: 54,
                    consultName: '下载专区',
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 7,
                    showPublishTime:true,
                    moreUrl:'/download'
                },
                year:new Date().getFullYear()
            }
        },

        mounted () {
            /*轮播图*/
            getRecommendList({
                pageNum: 0,
                pageSize: 5,
                posf: 22,
                posc: null,
                order: 1
            }).then((response) => {
                this.topCarousel = response.data.data.list;
            })

                        // 创建cnzz统计js
            const script = document.createElement('script')
            script.src = 'https://v1.cnzz.com/z_stat.php?id=1280138296&web_id=1280138296'
            script.language = 'JavaScript'
            document.body.appendChild(script)
        },
        methods: {
            openTarget(url){
                window.open(url);
            }
        }
    }
</script>
<style scoped>
    .mb_copy{margin:0 auto;text-align:center; color:#333333; height:31px;line-height:31px;font-size: 14px;margin-top: 3%;}
</style>
